<nav class="nav nav-secondary account-navbar">
  <!--Payment-->
  <a
    class="nav-item"
    [routerLink]="['/payment']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.cards.screenreader' | translate: { fgbdefault: 'Move to cards page' } }}"
  >
    <label>{{ 'account.nav.cards' | translate }}</label>
  </a>

  <a
    class="nav-item"
    [routerLink]="['/payment/transactions']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.transactions.screenreader' | translate: { fgbdefault: 'Move to transactions page' } }}"
  >
    <label>{{ 'account.nav.transactions' | translate }}</label>
  </a>
</nav>
